/* Eases the logo marquee down to a slow crawl on hover (instead of stopping dead) and back up on leave. */
(function () {
  var HOVER_SPEED = 0.25;
  var EASE = 0.08;

  function init(viewport) {
    var track = viewport.querySelector('.logo-marquee__track');
    if (!track || viewport.dataset.marqueeReady) return;
    viewport.dataset.marqueeReady = 'true';

    var target = 1;
    var current = 1;
    var frame = null;

    function getAnimation() {
      return track.getAnimations && track.getAnimations()[0];
    }

    function step() {
      var animation = getAnimation();
      if (!animation) {
        frame = null;
        return;
      }
      current += (target - current) * EASE;
      if (Math.abs(target - current) < 0.005) current = target;
      animation.playbackRate = current;
      frame = current === target ? null : requestAnimationFrame(step);
    }

    function setTarget(value) {
      target = value;
      if (!frame) frame = requestAnimationFrame(step);
    }

    viewport.addEventListener('mouseenter', function () {
      setTarget(HOVER_SPEED);
    });
    viewport.addEventListener('mouseleave', function () {
      setTarget(1);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.logo-marquee__viewport').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
